export const isNumeric = (str: string) => {
  return /^\d+$/.test(str);
};

export const isFormattedNumber = (str: string) => {
  const validFormat = /^(?!.*(?:, | ,))[\d\s.,]+$/.test(str);
  if (!validFormat) return false;

  const digitsOnly = String(str).match(/[\d]+/g);
  if (!digitsOnly) return false;

  const normalized = digitsOnly.join('');
  return !Number.isNaN(Number(normalized));
};
